export enum PriceSummaryDataHooks {
  ITEM = 'price-summary-item',
  LABEL = 'price-summary-label',
  DESCRIPTION = 'price-summary-description',
}
